import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from "@angular/core";
import { MatTableDataSource } from "@angular/material/table";
import { TableColumnType } from "src/app/constants/table";
import { TextType } from "src/app/constants/text-type";
import { CoverageSummaryItem, WizardCoverageSummary } from "src/app/models/enrollment-checkout";
import { TableColumn } from "src/app/models/table";

@Component({
    selector: 'mwp-benefit-enrollment-checkout-auto-enroll',
    templateUrl: './auto-enroll.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CheckoutAutoEnrollComponent implements OnInit {
    @Input() public wizardCoverageSummary: WizardCoverageSummary;
    
    @Output() public emitComplete: EventEmitter<any> = new EventEmitter();

    public autoMatTableData: MatTableDataSource<CoverageSummaryItem>;
    public autoTableColumns: TableColumn[] = [ 
        {
            columnName: 'Benefit',
            propertyId: 'benefit',
            columnType: TableColumnType.label,
        },
        {
            columnName: 'Tier',
            propertyId: 'tier',
            columnType: TableColumnType.label,
        },
        {
            columnName: 'Frequency',
            propertyId: 'frequency',
            columnType: TableColumnType.label,
        },
        {
            columnName: 'Summary',
            propertyId: 'summary',
            columnType: TableColumnType.label,
        },
        {
            columnName: 'Deduction',
            propertyId: 'employeeDeduction',
            columnType: TableColumnType.label,
            textType: TextType.currency,
            cssCustomHeaderClass: 'd-flex justify-content-end pe-2',
            cssCustomClass: 'd-flex justify-content-end pe-2'
        }
    ];

    constructor(
    ) {
    }

    ngOnInit(): void {
        this.autoMatTableData = new MatTableDataSource<CoverageSummaryItem>();
        this.autoMatTableData.data = this.wizardCoverageSummary.coverageSummaryItems;
    }

    public complete(): void {
        this.emitComplete.emit();
    }
}